<template>
  <div
    :class="{
      buttons: true,
      'buttons--bottom': align === `bottom`,
      'buttons--middle-right': align === `middle-right`,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "Buttons",
  props: {
    align: {
      type: String,
      default: "top",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/Buttons.scss";
</style>
